import { IStoreGroupInitialState } from '../types';

export const DEFAULT_STORE_GROUP_STATE: IStoreGroupInitialState = {
    storeGroups: [],
    storeGroup: null,
    count: null,
    loading: false,
    error: null,
    success: null,
};
